import { render, staticRenderFns } from "./customFilterNinja.vue?vue&type=template&id=6dc9902b&scoped=true&"
import script from "./customFilterNinja.vue?vue&type=script&lang=js&"
export * from "./customFilterNinja.vue?vue&type=script&lang=js&"
import style0 from "./customFilterNinja.vue?vue&type=style&index=0&id=6dc9902b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc9902b",
  null
  
)

export default component.exports